import { render } from "./advancedOptions.vue?vue&type=template&id=70b94f69&scoped=true"
import script from "./advancedOptions.vue?vue&type=script&lang=js"
export * from "./advancedOptions.vue?vue&type=script&lang=js"

import "./advancedOptions.vue?vue&type=style&index=0&id=70b94f69&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b94f69"]])

export default __exports__